<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col md="6">
                    <ValidationProvider name="semester_id" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('semester')">
                            <semesters-selectbox
                                v-model="form.semester_id"
                                :validate-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col md="6">
                    <ValidationProvider name="program" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('program')">
                            <program-selectbox v-model="form.program_code"
                                               :disabled="true"
                                               :validate-error="errors[0]"
                                               :department_code="form.department_code" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col md="6">
                    <ValidationProvider name="quota" rules="" v-slot="{ errors }">
                        <b-form-group :label="$t('quota')">
                            <b-form-input :state="errors[0] ? false : null"
                                          v-model="form.quota" />
                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col md="6">
                    <ValidationProvider name="application_group" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('application_group')">
                            <parameter-selectbox
                                :validate-error="errors[0]"
                                code="cartoon_animation_application_quota_placement_type"
                                v-model="form.application_group"
                            ></parameter-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
        </ValidationObserver>
        <div class="col-12 mt-3 d-flex">
            <b-button @click="createForm" type="button" variant="primary" class="btn-lg mr-2">
                {{ $t('save').toLocaleUpperCase('tr-TR') }}
            </b-button>
        </div>
    </div>
</template>

<script>
//Other
import {ValidationProvider, ValidationObserver} from "vee-validate"
//Service
import CartoonAnimationService from "@/services/CartoonAnimationService"
//Component
import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox"

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        ParameterSelectbox,
    },
    data() {
        return {
            formLoading: false,
            form: {
                semester_id: null,
                program_code: '03092101',
                faculty_code: null,
                department_code: null,
                quota: null,
            }
        }
    },
    methods: {
        async createForm() {
            const isValid = await this.$refs.formModalValidate.validate()
            if (isValid) {
                this.formLoading = true;
                CartoonAnimationService.storeQuotas(this.form)
                    .then((response) => {
                        this.$toast.success(this.$t("api." + response.data.message));
                        this.$emit("createFormSuccess")
                    })
                    .catch((error) => {
                        this.showErrors(error, this.$refs.formModalValidate)
                    }).finally(() => {
                    this.formLoading = false;
                });
            }
        }
    }
}
</script>
